import { useState } from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { DialogFooter } from '../ui/dialog';
import { Save, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export default function EditAudienceForm({ audience, onSave, onCancel }) {
  const [name, setName] = useState(audience.name || '');
  const [description, setDescription] = useState(audience.description || '');
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.error('Name is required');
      return;
    }
    setIsSaving(true);
    await onSave({ name: name.trim(), description: description.trim() });
    setIsSaving(false);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="audience-edit-name">Name</Label>
        <Input
          id="audience-edit-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          data-testid="audience-edit-name"
          required
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="audience-edit-desc">Description (optional)</Label>
        <Textarea
          id="audience-edit-desc"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={2}
          data-testid="audience-edit-desc"
        />
      </div>
      <div className="space-y-1">
        <Label className="text-xs text-muted-foreground">Filter (read-only)</Label>
        <p className="text-xs font-mono p-2 bg-muted/40 rounded border truncate">
          {audience.filter}
        </p>
      </div>
      <DialogFooter>
        <Button type="button" variant="outline" onClick={onCancel} disabled={isSaving}>
          Cancel
        </Button>
        <Button type="submit" disabled={isSaving} data-testid="audience-edit-save">
          {isSaving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Save className="w-4 h-4 mr-2" />}
          Save changes
        </Button>
      </DialogFooter>
    </form>
  );
}
